import { render, staticRenderFns } from "./BranchSitePage.vue?vue&type=template&id=66b4b4b6&scoped=true"
import script from "./BranchSitePage.vue?vue&type=script&lang=js"
export * from "./BranchSitePage.vue?vue&type=script&lang=js"
import style0 from "./BranchSitePage.vue?vue&type=style&index=0&id=66b4b4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4b4b6",
  null
  
)

export default component.exports